<template>
  <div id="vdo-set-unit-editor">
    <div class="-header">
      <div class="--title">
        <span>Edit Exam Question</span>
      </div>
      <span class="--subtitle">แก้ไขข้อสอบ</span>
    </div>

    <div class="-body">
      <div class="--item-container">
        รหัส INPUT
        ตัวเลือกแบบสุ่ม CHECKBOX
        คะแนน INPUT
        คำตอบข้อที่ INPUT
        คำถาม INPUT
        (ประเภทของคำถาม) (เฉพาะ Add)


        คำตอบ [ADD BUTTON] [REFRESH BUTTON]
        Table
        Mark ข้อที่ คำตอบ
        <!-- v-if="courseOutlineOptions.length > 0" -->
        <!-- <div class="--title"><span>เลือกวิชาจาก Course Outline</span></div> -->
        <!-- <div class="--item" v-for="(item) in courseOutlineRemainOptions" :key="item.id"> -->
          <!-- <vx-card>
            <vs-row vs-type="flex" vs-justify="center">
              <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" style="width: 32px; margin-right: 10px; margin-left: -30px">
                <vs-checkbox v-model="input" :vs-value="item" />
              </vs-col>
              
              <vs-col vs-w="6" vs-type="flex" vs-justify="flex-start" vs-align="center">
                <span><strong>{{ item.subject.code }} </strong> {{ item.subject.nameLocal }}</span>
              </vs-col>
              
              <vs-col vs-w="5" vs-type="flex" vs-justify="flex-end" vs-align="center">
                <span><strong>อาจารย์ </strong> {{ item.teacher | teacherName }}</span>
              </vs-col>
            </vs-row>
          </vx-card> -->
        <!-- </div> -->
      </div>
      <div class="--controllers">
        <vs-button
          @click="save"
        >
          <!-- :disabled="!isAvailableToCreate" -->
          Save
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, vue/no-unused-components */
import { state } from "../data";
import { loadData } from '../data/data-loader';
import { submitForm } from "../data/data-handlers";
// import { transformCheckboxInputToCourseOutlineRegistrationInput } from "../data/data-modellers";
import Block from "@/components/common-ui/block/index.vue";
import InputBox from "@/components/common-ui/forms/input-box/index.vue";
import TextArea from "@/components/common-ui/forms/textarea/index.vue";
import SelectBox from "@/components/common-ui/forms/select-box/index.vue";

export default {
  components: {
    Block
  },
  data() {
    return {
      local: state.local,
      store: state.store,
      selection: state.local.filterSelection,
      form: state.local.form,
      list: state.local.list,
      input: [],
    }
  },
  computed: {
    subjectOptions() {
      return state.local.selectorOptions.subject;
    },
    courseOutlineOptions() {
      return state.local.selectorOptions.courseOutline;
    },
    courseOutlineRemainOptions() {
      // console.log(this.list);
      const used = this.list.map(item => item.courseOutline.id);
      // console.log("used", used);
      const remain = state.local.selectorOptions.courseOutline.filter(item => {
        // console.log(item);
        return !used.includes(item.id);
      })
      // console.log(remain);
      return remain;
    }
  },
  methods: {
    handleCourseOutlineUnitSelect(data) {
      this.form.courseOutlineUnitId = data.multipleValues.courseOutlineUnitId;
      this.form.vdoSetUnitInput.unitSeq = data.multipleValues.unitSeq;
    },
    handleRemarkInput({ data }) {
      this.form.vdoSetUnitInput.remark = data;
    },
    async save() {
      const courseOutlineRegistrationInput = this.input.map(item => {
        const input = { ...this.form.filter };
        input.academicPeriodId = this.selection.academicPeriod.id; // Fill by filter
        input.periodCode = this.selection.academicPeriod.periodCode; // Fill by filter
        input.degreeId = item.degree.id;
        input.subjectGroupId = item.subjectGroup.id;
        input.subjectId = item.subject.id;
        input.subjectCode = item.subject.code;
        input.subjectName = item.subject.nameLocal;
        input.courseOutlineId = item.id;
        input.teacherId = item.teacher.id;
        input.teacherCode = item.teacherCode;
        return input;
      });
      // this.form.courseOutlineRegistrationInput = courseOutlineRegistrationInput;

      const result = await submitForm({ courseOutlineRegistrationInput });

      if (result.status.success) {
        alert("Add new Course Outline Registration success");
        this.local.editor = { active: false };
        loadData();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// @import "common-scoped";

.editor #vdo-set-unit-editor {
  width: 100%;
  height: 100%;
  padding-bottom: 100px;

  & .-header {
    width: 100%;
    display: block;
    margin-bottom: 20px;

    & .--title {
      font-size: 2rem;
      color: #6f66b9;
      padding-bottom: 1rem;
      width: 100%;
      height: 3rem;
      border-bottom: 2px solid #e8e8e8;
    }
    & .--subtitle {
      margin-top: 1rem;
      font-size: 1rem;
    }
  }

  & .-body {
    display: flex;
    width: 100%;
    flex-direction: column;

    & .--title {
      margin-bottom: 20px;
      margin-top: 20px;
      text-align: center;

      & > span {
        font-size: 1.4rem;
        font-weight: 400;
      }
    }

    & .--item-container {
      display: block;
      width: 100%;

      & .--item {
        display: block;
        width: 100%;
        margin-bottom: 10px;
      }
    }

    & .--controllers {
      margin-top: 20px;
    }
  }
}
</style>
